import { render, staticRenderFns } from "./PlanModalSelector.vue?vue&type=template&id=2a22e193&"
import script from "./PlanModalSelector.vue?vue&type=script&lang=js&"
export * from "./PlanModalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports